import { Injectable } from '@angular/core';

import { Subject, concatMap, of } from 'rxjs';

import { TranslocoService } from '@ngneat/transloco';

import { Confirmation } from '@core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  source$ = new Subject<Confirmation>();
  clear$ = new Subject<string>();
  queue$ = new Subject<void>();

  pending: boolean = false;
  visible: boolean = false;
  queue: Confirmation[] = [];

  confirmOpen$ = new Subject<Confirmation>();
  confirmClose$ = new Subject<Confirmation>();

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService) {
    // check the queue at least once a second
    setInterval(() => {
      if (this.visible) {
        return;
      }

      if (this.queue.length > 0) {
        this.queue$.next();
      }
    }, 1000);

    this.queue$
      .pipe(
        concatMap(() => {
          if (!this.pending && !this.visible && this.queue.length > 0) {
            const opts = this.queue.shift();

            if (opts === undefined) {
              return of();
            }

            this.pending = true;

            setTimeout(() => {
              this.source$.next(opts);
              this.visible = true;
            }, 250);
          }

          return of();
        })
      )
      .subscribe();

    this.confirmClose$.pipe().subscribe(() => {
      this.queue$.next();
    });
  }

  confirm(options: Confirmation) {
    options.title = options.title ?? this.translate('core.components.confirm.title');
    options.acceptLabel = options.acceptLabel ?? this.translate('core.components.confirm.accept.label');
    options.rejectLabel = options.rejectLabel ?? this.translate('core.components.confirm.reject.label');
    options.cancelLabel = options.cancelLabel ?? this.translate('core.components.confirm.cancel.label');

    this.add(options);
  }

  add(options: Confirmation) {
    this.queue.push({
      ...options,
    });

    this.queue$.next();
  }

  clear(key?: string) {
    this.clear$.next(key || null);
  }
}
